import styled from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { OUTLINE_COLOR, TEXT_GREY_LIGHT } from '@CSSVars/colors'

export const _LeadAutoComplete = styled.div`
input {
    width: 100%;
    padding: 15px;
    border: 1px solid ${OUTLINE_COLOR} !important;

  }
  .react-autosuggest__suggestions-container {
      position: absolute;
      width: 100%;
    }
  .react-autosuggest__suggestions-container--open {
    max-height: 250px;
    overflow-y: scroll;
    box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.14) !important;
  }
  .react-autosuggest__input::placeholder {
    color: ${TEXT_GREY_LIGHT};
  }
  @media screen and (max-width: 767px) {
    .react-autosuggest__suggestions-container--open {
      position: absolute;
      width: 100% !important;
      max-height: 250px;
      overflow-y: scroll;
    }
  }
`
